import { render, staticRenderFns } from "./application-pdf-documentation-section.vue?vue&type=template&id=5889565c&scoped=true&"
import script from "./application-pdf-documentation-section.vue?vue&type=script&lang=ts&"
export * from "./application-pdf-documentation-section.vue?vue&type=script&lang=ts&"
import style0 from "./application-pdf-documentation-section.vue?vue&type=style&index=0&id=5889565c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5889565c",
  null
  
)

export default component.exports